<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/productrecord/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="所属客户" prop="userId">
          <el-select v-model="searchForm.userId" :filterable="true" :clearable="true">
            <el-option :label="item.userName" :value="item.userId" v-for="item in userList" :key="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属仓库" prop='warehouseId'>
          <el-select v-model="searchForm.warehouseId" :filterable="true" :clearable="true">
            <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="item in warehouseList"
              :key="item.warehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品种规格" prop='specId'>
          <el-input clearable v-model="specName" @focus="dialogVisible = true"
            placeholder="品种规格" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属仓库"
          prop="warehouseName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="存储数量"
          prop="manQuantity"></el-table-column>
        <!-- <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属客户" prop="userName"></el-table-column> -->
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text"
                @click="$router.push('/inventorymanage/list?specId=' + row.specId + '&warehouseId=' + row.warehouseId)">详情</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'InventoryManage',
  components: {
    SpecChoose
  },
  mixins: [keepAlive],
  data() {
    return {
      dialogVisible: false,
      userList: [],
      warehouseList: [],
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        specId: '',
        userId: '',
        warehouseId: ''
      },
      specName: ''
    }
  },
  created() {
    this.loadData()
    this.loadWarehouseList()
    this.loadUserList()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    onSpecSelect(data) {
      console.log('data', data)
      this.searchForm.specId = data.specId
      this.specName = data.specName
      this.dialogVisible = false
    },
    loadWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.warehouseList = res.list || []
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByNum, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.specName = ''
      this.onSearch()
    },
    deleteRow(recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.prodManage.deleteScProRecord, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
